<template functional>
  <div>
    <el-tag :type="$options.ColorType(props)">
      {{ $options.ValueStatus(props) }}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: "ElTag",

  ColorType() {
    return "danger";
  },

  ValueStatus(props) {
    return props.rowValue;
  }
};
</script>

<style></style>
